function showRewardSubscriptionModal() {
    console.log('Clicked');
    $('.modal-backdrop').hide();
    $('.subscriptionRewardModalBackdrop').show();
}

function closeModal(e) {
    $(e.currentTarget).closest('.modal-backdrop').hide();
}

$(function () {
    $('body').on('click', '.closeModal', closeModal);
    $('.open-btn').on('click', showRewardSubscriptionModal);
});
